import { render } from "./tabVariantes.vue?vue&type=template&id=4da65315&scoped=true"
import script from "./tabVariantes.vue?vue&type=script&lang=js"
export * from "./tabVariantes.vue?vue&type=script&lang=js"

import "./tabVariantes.vue?vue&type=style&index=0&id=4da65315&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da65315"]])

export default __exports__